import { useEffect } from 'react';

import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';

import {
  DAYJS_LOCALES_IMPORT,
  UPDATE_DAYJS_LOCALE_CONFIG,
} from '@/shared/services/localization';
import { useAppState } from '@/shared/store/app-store/app-store';

dayjs.extend(updateLocale);

export const useLocaleListener = () => {
  const { i18n, lang } = useAppState();

  useEffect(() => {
    if (!i18n) return;

    if (lang) {
      i18n
        .changeLanguage(lang)
        .then(() => {
          DAYJS_LOCALES_IMPORT[lang]()
            .then(() => {
              dayjs.locale(lang);

              dayjs.updateLocale(lang, UPDATE_DAYJS_LOCALE_CONFIG[lang]);
            })
            .catch((err) => {
              console.error(err);
            });
        })
        .catch((err) => {
          console.error(err);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang, !!i18n]);
};
